import { Injectable } from "@angular/core";
import { FormControl, AbstractControl } from "@angular/forms";

@Injectable()
export class ValidationHelperService {
    constructor() { }

    // https://github.com/angular/angular/issues/11774#issuecomment-264706699
    markAllTouched(control: AbstractControl) {
        if (control.hasOwnProperty("controls")) {
            control.markAsTouched({ onlySelf: true }) // mark group
            let ctrl = <any>control;
            for (let inner in ctrl.controls) {
                this.markAllTouched(ctrl.controls[inner] as AbstractControl);
            }
        }
        else {
            (<FormControl>(control)).markAsTouched({ onlySelf: true });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/shared/validation-helper.service.ts